import { NgModule, ErrorHandler } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FoodRootComponent } from 'app/food';
import {
    PartnerDashboardRootComponent,
    PartnerDashboardSwitchComponent,
    PartnerOrdersRootComponent,
    PartnerMartLocationsRootComponent,
    PartnerEmployeesRootComponent,
    PartnerInventoryRootComponent,
    PartnerFinanceRootComponent,
    PartnerMarketingRootComponent,
    PartnerAppconfigRootComponent,
    PartnerInsightsRootComponent,
    PartnerSettingsRootComponent
} from 'app/partner';
import { MerchantStoreOnboardingComponent } from 'app/merchant';
import { CommsRootComponent } from 'app/comms';
import { OpsTowerRootComponent } from 'app/ops-tower';
import { SettingsRootComponent } from 'app/settings';
import {canActivate} from 'app/providers/permission.guard';
import { ErrorProvider } from 'app/providers';
import { JL } from 'jsnlog';
import { PageNotFoundComponent } from '@shared/components/page-not-found/page-not-found.component';
import { COMPLAINTS_ROOT_REDIRECT } from './app-complaints-redirect';

const routes: Routes = [
    // Admin
	{ path: 'xpressadmin', loadChildren: () => import('./portal-modules/xpressadmin/modules/xpressadmin.module').then(m => m.XpressAdminModule) },
	{ path: 'region', loadChildren: () => import('./portal-modules/region/modules/region.module').then(m => m.RegionModule) },
	{ path: 'opstower', loadChildren: () => import('./portal-modules/ops-tower/modules/ops-tower.module').then(m => m.OpsTowerModule) },
	{ path: 'operator', loadChildren: () => import('./portal-modules/operator/modules/operator.module').then(m => m.OperatorModule) },
	{ path: 'operator-login', redirectTo: 'operator/login', pathMatch: 'full' },
	{ path: 'operator-signup', redirectTo: 'operator/signup', pathMatch: 'full' },

	//Experience
	{ path: 'experience', loadChildren: () => import('./experience/experience.module').then(m => m.ExperienceModule) },

    // Partner portal
    { path: 'partner-dashboard-root', component: PartnerDashboardRootComponent },
    { path: 'partner-dashboard-switch', component: PartnerDashboardSwitchComponent },
    { path: 'merchant-store-onboarding', component: MerchantStoreOnboardingComponent },
    { path: 'partner-orders-root', component: PartnerOrdersRootComponent },
    { path: 'partner-mart-locations-root', component: PartnerMartLocationsRootComponent },
    { path: 'partner-employees-root', component: PartnerEmployeesRootComponent },
    { path: 'partner-inventory-root', component: PartnerInventoryRootComponent },
    { path: 'partner-finance-root', component: PartnerFinanceRootComponent },
    { path: 'partner-appconfig-root', component: PartnerAppconfigRootComponent },
    { path: 'partner-marketing-root', component: PartnerMarketingRootComponent },
    { path: 'partner-insights-root', component: PartnerInsightsRootComponent },
    { path: 'partner-settings-root', component: PartnerSettingsRootComponent },
    { path: 'partner-food-root', component: FoodRootComponent },

    // Boracay
    { path: 'ops-tower-root', component: OpsTowerRootComponent, canActivate: [canActivate], data: { permission: 'ops-tower' } },
    COMPLAINTS_ROOT_REDIRECT,
    { path: 'settings-root', component: SettingsRootComponent, canActivate: [canActivate], data: { permission: 'settings' } },
    { path: 'comms-root', component: CommsRootComponent, canActivate: [canActivate], data: { permission: 'comms' } },

	{ path: 'xpressadmin/pagenotfound', component: PageNotFoundComponent },
	//{ path: '**', redirectTo: 'xpressadmin/pagenotfound' }
];

@NgModule({
    providers:[{ provide: ErrorHandler, useClass: ErrorProvider }, { provide: 'JSNLOG', useValue: JL }],
	imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
